import { useTranslation } from "react-i18next";
import { Button, CardNotification } from "@foris/avocado-suite";
import type { AssignmentProposalErrorCode } from "@models/ISchema";
import { proposalErrorMessageKey } from "@utils/assignmentProposal";
import styles from "./proposalLoadError.module.scss";

interface ProposalLoadErrorProps {
  /** Code the backend answered with; null for a request failure or an unreadable proposal. */
  errorCode: AssignmentProposalErrorCode | null;
  onRetry: () => void;
}

/**
 * Shown instead of the editor when the proposal it was opened for could not be loaded. The form is
 * never rendered in that case: an empty editor would look like a new proposal.
 */
const ProposalLoadError = ({ errorCode, onRetry }: ProposalLoadErrorProps) => {
  const { t } = useTranslation();

  return (
    <section className={styles.proposalLoadError} role="alert">
      <CardNotification
        state="error"
        title={t(proposalErrorMessageKey(errorCode, "load"))}
        outlined
      >
        <Button variant="ghost" onClick={onRetry}>
          {t("assignation-edit.proposal.load.retry")}
        </Button>
      </CardNotification>
    </section>
  );
};

export default ProposalLoadError;
